import React from 'react';

export interface SliderSlidesContextValue {
	/**
	 * Function to wrap content with slide containers
	 * @param content - The content to wrap
	 * @param key - Unique key for the slide
	 * @param isPending - Indicates if the slide is still loading (default is true, relevant for CmsRepeater)
	 * @returns The wrapped content
	 */
	renderSlide?: (content: React.ReactNode, key: string, isPending?: boolean) => React.ReactNode;
}

export const SliderSlidesContext = React.createContext<SliderSlidesContextValue>({});
export default SliderSlidesContext;
